// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2k_ND","empty":"ModalGraph_empty__2p_NB"};